import React from 'react'

const CorporateLogo2: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/corporate_logo2.svg" alt="corporate_logo2"/>
  )
}

export default CorporateLogo2